<template>
  <v-flex xs12>
    <!-- Vi label section-->

    <v-card flat>
      <vilabel-sub
        label-type="shot-label"
        label-caption="Shot labels"
        :fmid="filmMasterID"
        :count="countByType('shot-label')"
        :dirty="dirty"
      ></vilabel-sub>

      <vilabel-sub
        label-type="frame-label"
        label-caption="Frame labels"
        :fmid="filmMasterID"
        :count="countByType('frame-label')"
        :dirty="dirty"
      ></vilabel-sub>

      <vilabel-sub
        label-type="text"
        label-caption="Text"
        :fmid="filmMasterID"
        :count="countByType('text')"
        :dirty="dirty"
      ></vilabel-sub>

      <vilabel-sub
        label-type="logo"
        label-caption="Logos"
        :fmid="filmMasterID"
        :count="countByType('logo')"
        :dirty="dirty"
      ></vilabel-sub>

      <vilabel-sub
        label-type="transcript"
        label-caption="Transcript"
        :fmid="filmMasterID"
        :count="countByType('transcript')"
        :dirty="dirty"
      ></vilabel-sub>

      <vilabel-sub
        label-type="shot"
        label-caption="Shot changes"
        :fmid="filmMasterID"
        :count="countByType('shot')"
        :dirty="dirty"
      ></vilabel-sub>

      <vilabel-sub
        label-type="segment-label"
        label-caption="Segment labels"
        :fmid="filmMasterID"
        :count="countByType('segment-label')"
        :dirty="dirty"
      ></vilabel-sub>

      <vilabel-sub
        label-type="explicit-content"
        label-caption="Explicit content"
        :fmid="filmMasterID"
        :count="countByType('explicit-content')"
        :dirty="dirty"
      ></vilabel-sub>

      <vilabel-sub
        label-type="face-label"
        label-caption="Faces"
        :fmid="filmMasterID"
        :count="countByType('face-label')"
        :dirty="dirty"
        :thumbnail="true"
      ></vilabel-sub>

      <vilabel-sub
        label-type="celebrity"
        label-caption="Celebrities"
        :fmid="filmMasterID"
        :count="countByType('celebrity')"
        :dirty="dirty"
      ></vilabel-sub>

      <vilabel-sub
        label-type="person-label"
        label-caption="People"
        :fmid="filmMasterID"
        :count="countByType('person-label')"
        :dirty="dirty"
      ></vilabel-sub>
    </v-card>
  </v-flex>
</template>
<script>
import { MasterTypes } from '@/gql'
import { getIconColor, getIcon, settings } from '@/js/store'
import { mapState, mapMutations, mapGetters } from 'vuex'
import { vxMaps } from '@/js/vxstore'
import Vilabelsub from '@/components/Vilabelsub'

export default {
  components: {
    'vilabel-sub': Vilabelsub,
  },
  props: {
    reason: Object,
    editing: String,
    editable: Boolean,
    dirty: Boolean,
    master: Object
  },
  methods: {
    refreshFilm(film) {
      this.$emit('refreshfilm', film)
    },
    countByType(t) {
      return this.countsByType && this.countsByType[t]
    },
    getIcon(name) {
      return getIcon(name)
    },
    getIconColor(name) {
      return getIconColor(name)
    },

    showCard(prop) {
      return this.showLabels && (this.vActiveSub === prop || !this.vActiveSub)
    },
    showCardDetail(prop) {
      return (
        this.showLabels && (prop ? this.vActiveSub === prop : this.vActiveSub)
      )
    },
    ...mapMutations(vxMaps.mutations),
  },
  data: () => ({
    MasterTypes: null,
    ViLabelProgress: null,
    polling: false,
    hideLabellingError: true,
    startingToPoll: false,
    pollInterval: 0,
    masterDirty: false,
  }),
  computed: {
    countsByType() {
      const data =
        this.MasterTypes && this.MasterTypes[0] && this.MasterTypes[0].ViLabels
      if (!data) return null
      // summarize that by label type
      return data.reduce((p, c) => {
        p[c.CountViGroup.type] = c.CountViGroup.countRows
        return p
      }, {})
    },
    showLabels() {
      return this.bigActiveSection === 'labelsection'
    },
    tooltips() {
      return settings.tooltips
    },

    labelColor() {
      return getIconColor('labels')
    },
    viLabelData() {
      return this.ViLabels
    },
    // whether to show a filimid chip in the film poster frame header section
    chipFits() {
      return !this.xs
    },
    xs() {
      return this.$vuetify.breakpoint.xs
    },
    film() {
      return this.reason && this.reason.Film
    },
    filmMaster() {
      return this.master
    },
    filmMasterID() {
      return this.filmMaster && this.filmMaster.id
    },
    ...mapState(vxMaps.state),
    ...mapGetters(vxMaps.getters),
  },
  apollo: {
    MasterTypes: {
      skip() {
        return !this.filmMasterID
      },
      query: MasterTypes,
      fetchPolicy: 'cache-and-network',
      variables() {
        return {
          filters: [
            {
              valueKey: 'id',
              value: this.filmMasterID,
            },
          ],
        }
      },
    },
  },
}
</script>
